import { render } from "./Hotline.vue?vue&type=template&id=49c490a2"
import script from "./Hotline.vue?vue&type=script&lang=js"
export * from "./Hotline.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTL-Project\\ChatBotSHLX\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__